import React, { useState } from 'react'
import './SearchBar.css';
import { Link } from "react-router-dom";
import CancelIcon from '@mui/icons-material/Cancel';

function SearchBar({ placeholder, data }) {

  const [filteredData, setFilteredData] = useState([]);

  const handleFilter = (event) => {
    const searchWord = event.target.value
    const newFilter = data.filter((value) => {
      return value.title.toLowerCase().includes(searchWord.toLowerCase());
    });

    if (searchWord === "") {
      setFilteredData([])
    }
    else {
      setFilteredData(newFilter);
    }

  }
  return (
    <div className="search">
      <div className="searchInputs">
        <input type="search" placeholder={placeholder} onChange={handleFilter} />
      </div>
      {filteredData.length != 0 && (
        <div className="dataResult absolute">
          {filteredData.slice(0, 10).map((value, key) => {
            return <Link to={value.link}><a className="dataItem">
              <p>{value.title}</p>
            </a></Link>

          })}
        </div>
      )}
    </div>
  )
}

export default SearchBar
